import { Navigate, Outlet } from 'react-router-dom';
import { getCurrentUser } from '@/lib/auth';

export default function AdminRoute() {
  const user = getCurrentUser();
  if (!user) return <Navigate to="/login" replace />;
  if (!user.isadmin) return <Navigate to="/unauthorized" replace />;
  return <Outlet />;
}
